'use client';
import { FC } from 'react';
import { IBeautyBrandsComponent } from './beauty-brands.interface';
import { IStoreDetails } from '../store-details/store-details.interface';
import BrandsList from '../brands-list';

import styles from './beauty-brands.module.scss';

const BeautyBrands: FC<Pick<IStoreDetails, 'layout'>> = ({ layout }) => {
  const beautyBrands = layout?.sections?.mainContentCollection?.components?.find(
    (item: any) => item.componentId === 'beautyBrandsComponent'
  ) as IBeautyBrandsComponent;

  if (!beautyBrands?.data?.length) return null;

  return (
    <div className={styles.beautyBrandsContainer}>
      <BrandsList data={beautyBrands?.data} />
    </div>
  );
};

export default BeautyBrands;
